import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from 'react-ga4';

// Initialize GA4 with Measurement ID from environment variables
const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

if (measurementId) {
  ReactGA.initialize(measurementId);
  console.log('✅ GA4 initialized successfully');
} else {
  console.warn('⚠️ GA4 Measurement ID not found in environment variables');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);